
import { useState, useEffect } from "react";
import NowPosts from "../components/NowPosts"
import sanityClient from "../src/client.js";
import { BsCalendar3 } from "react-icons/bs";
import NowCard from "../components/NowCard"

const POST_QUERY = `*[
    _type == "Now"
  ] | order(date desc)
    [0]
  `

export default function Now(){
    const [posts, setPosts] = useState(null);
    
        useEffect(() => {
            sanityClient.fetch(POST_QUERY,{}, {
                // cache: 'force-cache',
                // next: { revalidate: 30}
            })
            .then((data) => setPosts(data))
            .catch(console.error)
        },[])
     
     
        // let renderedPosts
    
        // if (posts) {
        //     renderedPosts = posts.map(post =>{
        //         return (
        //             <NowCard 
        //                 key={post._id}
        //                 title={post.title} 
        //                 text={post.content} 
        //                 date={post.date}
                        
        //             />
        //         )
        //     })
            
        // }

    return (
        <div className="main-body">
            
            <div className="container">
                <div className="now-intro">
                    <h1>What I’m doing now</h1>
                    <p>(This is a <a href="https://nownownow.com/about">now</a> page, and if you have your own site, you should make one, too.) </p>
                </div>
                {posts && <NowCard 
                    key={posts._id}
                    title={posts.title} 
                    text={posts.content} 
                    
                    
                /> }
                {/* <NowPosts /> */}
            </div>
        </div>
    )
}